// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 175) return "static/chunks/175-b3e21882d89a45da.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"275":"fb8d73648d932434","793":"688c48b8dd694669","803":"bec411e575f1c08c"}[chunkId] + ".js";
};